export default __webpack_public_path__ + "static/media/arrow-neutral-small.0ca4d255.svg";